import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 组件

import animated from 'animate.css'
Vue.use(animated);
// 动画
import Watermark from './util/watermark';
// 复制
import imgPreview from './util/preview'
Vue.use(imgPreview)
// 图片预览
import Print from 'vue-print-nb'
// Global instruction 
Vue.use(Print);

import axios from './axios/http'
import api from './api' // 导入api接口
Vue.prototype.$api = api;
// 接口

import init from './util/global'
Vue.prototype.$init = init;

import storage from './util/storage'
Vue.prototype.$storage = storage;
// 存储

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App),
	created() {
		Watermark.set('');
	  }
}).$mount('#app')
